import { render, staticRenderFns } from "./BlankProvider.vue?vue&type=template&id=e25e983a&lang=pug&function=true&"
import script from "./BlankProvider.vue?vue&type=script&lang=js&"
export * from "./BlankProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports